import { getThemeValue } from './getTheme';
import type { System } from '../types/system';

const positiveOrNegative = (scale: System.Scale, value: string | number) => {
  if (typeof value !== 'number' || value >= 0) {
    if (typeof value === 'string' && value.startsWith('-')) {
      const valueWithoutMinus = value.substring(1);
      const n = getThemeValue(scale, valueWithoutMinus, valueWithoutMinus);

      if (typeof n === 'number') return n * -1;

      return `-${n}`;
    }

    return getThemeValue(scale, value, `${value}`);
  }

  const absolute = Math.abs(value);
  const n = getThemeValue(scale, absolute, `${absolute}`);
  if (typeof n === 'string') return `-${n}`;

  return Number(n) * -1;
};

export default positiveOrNegative;
